import { gql } from "graphql-tag";

export const CREATE_SPRINT = gql`
  mutation CreateSprint(
    $projectId: ID!
    $label: String
    $startDate: Date!
    $endDate: Date!
    $color: String
    $active: Boolean
  ) {
    createSprint(
      projectId: $projectId
      label: $label
      startDate: $startDate
      endDate: $endDate
      color: $color
      active: $active
    ) {
      status
      error
      data {
        id
        number
        label
        projectId
        startDate
        endDate
        color
        active
      }
    }
  }
`;

export const UPDATE_SPRINT = gql`
  mutation UpdateSprint(
    $id: ID!
    $projectId: ID!
    $label: String
    $startDate: Date
    $endDate: Date
    $color: String
    $active: Boolean
  ) {
    updateSprint(
      id: $id
      projectId: $projectId
      label: $label
      startDate: $startDate
      endDate: $endDate
      color: $color
      active: $active
    ) {
      status
      error
      data {
        id
        number
        label
        projectId
        startDate
        endDate
        color
        active
      }
    }
  }
`;

export const ARCHIVE_SPRINT = gql`
  mutation ArchiveSprint($id: ID!, $projectId: ID!) {
    archiveSprint(id: $id, projectId: $projectId) {
      status
      error
      data {
        id
        number
        label
        projectId
        startDate
        endDate
        color
        active
      }
    }
  }
`;
